<template>
	<section class="sub_container">
		<div class="search_form">
		<a href="javascript:void(0);" class="close" title="close" @click="close"></a>
			<h2>주문 상세보기</h2>
		</div>
    <div class="sub_contents">
      <div class="sub_contents_wrap">
        <h1>견적요청 컨텐츠</h1>
        <section id="con1" class="ins_con_wrap mb0"
						v-if="order.orderMain.orderClassCode == '12' || order.orderMain.orderClassCode == '22'"
						@click="clickInsuranceInfo">
					<dl class="po po1">
						<dt :class="{on: isShowInsuranceInfo}">
              <span>보험정보</span>
            </dt>
						<dd :style="{display: showInsuranceInfoBlock}">
              <div class="contents mg0 bordn0">
								<div class="row">
									<div class="cell">
										<label for="">보험사</label>
										<input type="text" class="input-text w100-p" placeholder="보험사" readonly
												v-model="order.insuranceClaim.insurancePartnerName">
									</div>
									<div class="cell">
										<label for="">사고번호</label>
										<input type="text" class="input-text w100-p" placeholder="사고번호" readonly
												v-model="order.insuranceClaim.accidentId">
									</div>
								</div>
								<div class="row">
									<div class="cell">
										<label for="">접수일자</label>
                    <div class="form-group mt10">
											<input type="text" placeholder="접수일자" autocomplete="off" readonly
													v-model="order.insuranceClaim.requestDate">
                    </div>
									</div>
									<div class="cell">
										<label for="">순번</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="순번" readonly
													v-model="order.insuranceClaim.sequenceId">
                    </div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
										<label for="">차량번호</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="차량번호" readonly
													v-model="order.insuranceClaim.carId">
										</div>
									</div>
									<div class="cell">
										<label for="">담보</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="담보" readonly
													v-model="order.insuranceClaim.securityTypeCode">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
										<label for="">보험 담당자</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="보험 담당자" readonly
													v-model="order.insuranceClaim.chargeUserName">
                    </div>
									</div>
									<div class="cell">
										<label for="">담당자 연락처</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="담당자 연락처" readonly
													v-model="order.insuranceClaim.chargePhoneNumber">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>담당자 FAX(선택)</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="담당자 FAX(선택)" readonly
													v-model="order.insuranceClaim.chargeFaxNumber">
										</div>
									</div>
									<div class="cell">
										<label for="">의뢰 일자</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="주문처" readonly
													v-model="order.insuranceClaim.requestDate">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>SK 담당자</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="SK 담당자" readonly
													v-model="order.insuranceClaim.sknUserNo">
                    </div>
									</div>
									<div class="cell">
                    <label for="">차명</label>
                    <div class="form-group mt10">
											<input type="text" class="input-text w100-p" placeholder="차명" readonly
													v-model="order.insuranceClaim.carName">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>브랜드</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="브랜드" readonly
													v-model="order.insuranceClaim.brandName">
                    </div>
									</div>
									<div class="cell">
                    <label>차대번호</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="차대번호" readonly
													v-model="order.insuranceClaim.vehicleId">
                    </div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>공업사</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="공업사" readonly
													v-model="order.insuranceClaim.servicePartnerName">
                    </div>
									</div>
									<div class="cell">
                    <label>공업사 연락처</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="공업사 연락처" readonly
													v-model="order.insuranceClaim.servicePartnerPhoneNumber">
                    </div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>공업사 주소</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="공업사 주소" readonly
													v-model="order.insuranceClaim.servicePartnerAddress">
                    </div>
									</div>
									<div class="cell">
                    <label>담당 대리점</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="담당 대리점" readonly
													v-model="order.insuranceClaim.orderPartnerName">
                    </div>
									</div>
								</div>
								<div class="row">
									<div class="cell">
                    <label>SK 담당자</label>
                    <div class="form-group mt10">
                      <input type="text" class="input-text w100-p" placeholder="SK 담당자" readonly
													v-model="order.insuranceClaim.sknUserNo">
                    </div>
									</div>
									<div class="cell">
                    <label style="height:19px"></label>
									</div>
								</div>
								<div class="row">
                  <div class="cell w100-p">
                    <label class="mb0">참고사항</label>
                    <div class="form-group mt10">
                      <textarea name="name" rows="8" class="input-text" readonly
													v-model="order.insuranceClaim.memo"></textarea>
                    </div>
									</div>
								</div>
                <div class="board_list_top mt10 mb5 w100-p bgWhite">
									<div class="sub_left_wrap">
										<div class="destxt ">
											주문금액
											<span class="disin ml10">
												{{order.orderMain.orderPrice | currency}}
											</span>
											<span> 원</span>
										</div>
									</div>
									<div class="sub_right_wrap">
										<div class="destxt ">
											VAT
											<span class="disin ml10">
												{{Math.round((order.orderMain.orderPrice * 0.1) * 100) / 100 | currency}}
											</span>
											<span> 원</span>
										</div>
									</div>
									<div class="sub_left_wrap ">
										<div class="destxt ">
											총 결제금액
											<span class="disin ml10">
												{{order.orderMain.orderPrice + Math.round((order.orderMain.orderPrice * 0.1) * 100) / 100 | currency}}
												<span> 원</span>
											</span>
										</div>
									</div>
								</div>
							</div>
            </dd>
					</dl>
				</section>
				<div class="sub_contents_wrap">
					<h1></h1>
					<div class="board_list_top mb5" v-if="false">
						<div class="sub_left_wrap">
							<div class="destxt02"><h2><span>주문정보 개요</span></h2></div>
						</div>
						<div class="sub_right_wrap">
							<div class="btn_area pb0">
								<a href="" class="button white"><span>주문조회 팁</span></a>
							</div>
						</div>
					</div>
					<div class="day_report-02 mb10 pb0">
						<div class="day_box">
							<div class="title">
								<span>주문 번호</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderId}}</span>
							</div>
						</div>
						<div class="day_box">
							<div class="title">
								<span>주문 일시</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderDate}}</span>
							</div>
						</div>
					</div>
					<div class="day_report-02 bordn0 pt0">
						<div class="day_box">
							<div class="title">
								<span>SO 번호</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.erpSoId}}</span>
							</div>
						</div>
						<div class="day_box">
							<div class="title">
								<span>대리점</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderPartnerName}}</span>
							</div>
						</div>
					</div>
					<div class="day_report-02 bordn0  pt0">
						<div class="day_box">
							<div class="title">
								<span>배송처</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.customerName}}</span>
							</div>
						</div>
						<div class="day_box">
							<div class="title">
								<span>주문 물류</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.logisticsPartnerName}}</span>
							</div>
						</div>
					</div>
					<div class="day_report-02 bordn0  pt0">
						<div class="day_box">
							<div class="title">
								<span>구분</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderClassName}}</span>
							</div>
						</div>
						<div class="day_box">
							<div class="title">
								<span>최종상태</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderStatusName}}</span>
							</div>
						</div>
					</div>
					<div class="day_report-02 bordn0 mb10 pt0">
						<div class="day_box">
							<div class="title">
								<span>주문 담당자</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.chargeUserName}}</span>
							</div>
						</div>
						<div class="day_box">
							<div class="title">
								<span>요청 금액</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.orderPrice | currency}}</span>
							</div>
						</div>
					</div>
					<div class="day_report-02 bordn0 mb10 pt0">
						<div class="day_box">
							<div class="title">
								<span>배송유형</span>
							</div>
							<div class="price">
								<span>{{order.orderMain.deliveryMethodCodeName}}</span>
							</div>
						</div>
					</div>
        </div>
        <div class="board_list_top mt50 mb10">
          <div class="sub_left_wrap">
            <h2>상세 상품정보</h2>
          </div>
        </div>
				<div class="board_list type03 tbl_box" style="height: 358px">
          <table class="board_table" style="table-layout:fixed; width:1375px;">
            <caption class="hide">주문내역 테이블</caption>
            <colgroup>
              <col style="width:35px;"> <!-- No -->
              <col style="width:100px;"> <!-- 상품코드 -->
              <col style="width:150px;"> <!-- 상품명 -->
              <col style="width:50px;"> <!-- 안성재고 -->
              <col style="width:50px;"> <!-- 서울재고 -->
              <col style="width:50px;"> <!-- 주문수량 -->
              <col style="width:80px;"> <!-- 주문단가 -->
              <col style="width:90px;"> <!-- 주문금액 -->
              <col style="width:100px;"> <!-- QT 번호 -->
              <col style="width:60px;"> <!-- 취소 여부 -->
              <col style="width:100px;"> <!-- SO 번호 -->
              <col style="width:50px;"> <!-- 수량 -->
              <col style="width:100px;"> <!-- DL번호 -->
              <col style="width:50px;"> <!-- 수량 -->
              <col style="width:80px;"> <!-- DL일자 -->
              <col style="width:100px;"> <!-- BILL번호 -->
              <col style="width:80px;"> <!-- 지불일자 -->
              <col style="width:50px;"> <!-- 반품갯수 -->
            </colgroup>
            <thead>
              <tr>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="5" class="thbg-01">상품정보</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" class="thbg-02">주문요청 내역</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="3" class="thbg-03">SO (주문확정) </th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="3" class="thbg-04">DV (출고요청/출고확정)</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="2" class="thbg-05">입고예정</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" class="thbg-07">반품</th>
              </tr>
              <tr>
                <th scope="col">No</th>
                <th scope="col">상품코드</th>
                <th scope="col">상품명</th>
                <th scope="col">안성재고</th>
                <th scope="col">서울재고</th>
                <th scope="col">주문수량</th>
                <th scope="col">주문단가</th>
                <th scope="col">주문금액</th>
                <th scope="col">QT 번호</th>
                <th scope="col">취소여부</th>
                <th scope="col">SO 번호</th>
                <th scope="col">수량</th>
                <th scope="col">DL번호</th>
                <th scope="col">수량</th>
                <th scope="col">DL일자</th>
                <th scope="col">BILL번호</th>
                <th scope="col">지불일자</th>
                <th scope="col">반품갯수</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in order.orderItemList" v-bind:key="index">
                <td> {{index + 1}} </td>
                <td> {{data.productId}} </td>
                <td class="tal"> {{data.productName}} </td>
                <td class="tar"> {{renderNumber(data.anseongAmount)}} </td>
                <td class="tar"> {{renderNumber(data.seoulAmount)}} </td>
                <td class="tar"> {{renderNumber(renderOrderAmount(data.orderAmount, data))}} </td>
                <td class="tar"> {{renderNumber(data.unitPrice)}} </td>
                <td class="tar"> {{renderNumber(data.orderPrice)}} </td>
                <td> {{data.qtId}} </td>
                <td> {{rederOrderItemStatus(data.orderItemStatusCode)}} </td>
                <td> {{data.soId}} </td>
                <td class="tar"> {{renderNumber(data.soCount)}} </td>
                <td> {{data.dlId}} </td>
                <td class="tar"> {{renderNumber(data.dlCount)}} </td>
                <td> {{data.dlDate}} </td>
                <td> {{data.billId}} </td>
                <td> {{data.billDate}} </td>
                <td class="tar"> {{renderNumber(data.itemReturnAmount)}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
	</section>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import AppConfig from '@/config'
import Utils from '@/modules/utils'

export default {
	name: 'orderStatusaDetail',
	data() {
		return {
      AppConfig,
      Utils,
			isShowInsuranceInfo: false,
			showInsuranceInfoBlock: 'none',
			order: {
				orderMain:{
					orderNo : 0,
					orderId : "",
					orderPartnerName : "",
					orderPrice : "",
					carId : "",
					brandName : "",
					chargeUserName : "",
					updateTimestamp : "",
					orderClassCode : null,
					erpSopId : "",
					dlId : "",
					billId : '',
					customerName : "",
					logisticsPartnerName : "",
					logisticsPartnerNo : "",
					orderClassName : "",
					orderStatusName : "",
					orderStatusCode : "",
					price : "",
					orderDate : "",
					sknChargeName : "",
					paymentTypeCode : "",
					deliveryMethodCodeName: ''
				},
				orderItemList:[],
				partnerInfo:{},
				insuranceClaim:{
					insurancePartnerName : "",
					accidentId : "",
					requestDate : "",
					sequenceId : "",
					carId : "",
					securityTypeCode : "",
					chargeUserName : "",
					chargePhoneNumber : "",
					chargeFaxNumber : "",
					requestDate : "",
					carName : "",
					brandName : "",
					vehicleId : "",
					servicePartnerName : "",
					servicePartnerPhoneNumber : "",
					servicePartnerAddress : "",
					sknUserNo : "",
					memo : "",
					claimPrice : "",
					actualClaimTax : "",
					adjustClaimPrice : "",
				}
			},
		}
	},
	methods: {
		close() {
			router.push('/order/OrderStatus');
		},
		goToList() {
      this.$router.push({name : 'OrderStatus'});
		},
		renderOrderAmount(value, data) {
			if (data.amount != 0) {
				return data.amount;
			}
			if (value == null || value == 0) {
				let anseongOrderAmount = data.anseongOrderAmount != null ? data.anseongOrderAmount : 0;
				let seoulOrderAmount = data.seoulOrderAmount != null ? data.seoulOrderAmount : 0;
				return anseongOrderAmount + seoulOrderAmount;
			}  else {
				return value;
			}

			return 0;
		},
		rederOrderItemStatus(value) {
			if(value == '90'){
				return '취소';
			}else{
				return '';
			}
		},
		renderNumber(val) {
			// if (val == null || val == 0 || val == '') {
			// 	return 0;
			// }
      return Utils.numberComma(val);
		},
		clickInsuranceInfo() {
			const orderinfo = this.order;
			if (orderinfo.orderMain.orderClassCode != '12' && orderinfo.orderMain.orderClassCode != '22') {
				return false;
			}

			if (!this.isShowInsuranceInfo) {
				this.isShowInsuranceInfo = true;
				this.showInsuranceInfoBlock = 'block';
			} else {
				this.isShowInsuranceInfo = false;
				this.showInsuranceInfoBlock = 'none';
			}
		}
	},
	mounted() {
		Utils.showLoading('order_form_grid');
		
		this.order.orderMain.orderNo = this.$route.params.orderNo;
		
    if (this.order.orderMain.orderNo == 0 || this.order.orderMain.orderNo == undefined) {
      this.goToList();
      return false;
		}

    Vue.httpClient
			.get('/order/orderStatusDetail', { params : { orderNo : this.order.orderMain.orderNo}})
			.then(response => {
        if ( response.data.result ) {
          this.order.orderMain = response.data.result.orderMain;
          this.order.orderItemList = response.data.result.orderItemList;
          this.order.partnerInfo = response.data.result.partnerInfo;
					this.order.insuranceClaim = response.data.result.insuranceClaim;
					
          if (this.order.orderItemList.length > 0) {

					} else {
						this.selectOrderItem();
					}


				} else {
					Vue.Alert.alert('잘못된 접근 입니다.');
				}
			})
      .catch((error) => {
        window.$Alert.alert('잘못된 접근 입니다.');
      })
			.finally(_ => {
				Utils.hideLoading('order_form_grid');
			});
		
	},
  filters: { 
    currency: value => { 
      if (!value) return '0' 
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") 
    }  
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/order/OrderStatusDetail.vue